require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-lorenzo-denti.json") })
        }
      }, "path---en-interviste-lorenzo-denti");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-lorenzo-denti!./.cache/json/en-interviste-lorenzo-denti.json
// module id = 586
// module chunks = 231608221292675